import script from "./Step1General.vue?vue&type=script&setup=true&lang=js"
export * from "./Step1General.vue?vue&type=script&setup=true&lang=js"

import "./Step1General.vue?vue&type=style&index=0&id=446b4cc9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-446b4cc9"]])

export default __exports__